/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Spaces_BlurbInputs */



/**
* | output |
* | --- |
* | "Spaces are your file repository and knowledge base. Upload or connect files, embed them, and the assistant can search and cite them in chats." |
*
* @param {Uno_Edu_Intro_Spaces_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_spaces_blurb = /** @type {((inputs?: Uno_Edu_Intro_Spaces_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Spaces_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spaces sind Ihr Dateirepository und Ihre Wissensbasis. Laden Sie Dateien hoch oder verbinden Sie sie, betten Sie sie ein, und der Assistent kann sie in Chats durchsuchen und zitieren.")
	return /** @type {LocalizedString} */ ("Spaces are your file repository and knowledge base. Upload or connect files, embed them, and the assistant can search and cite them in chats.")
});